import { render, staticRenderFns } from "./EditMenuModal.vue?vue&type=template&id=51aaf642&scoped=true&"
import script from "./EditMenuModal.vue?vue&type=script&lang=ts&"
export * from "./EditMenuModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditMenuModal.vue?vue&type=style&index=0&id=51aaf642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aaf642",
  null
  
)

export default component.exports